// extracted by mini-css-extract-plugin
export default {"body":"Icon_body__zCSEt","imageContainer":"Icon_imageContainer__nGcoO","linkName":"Icon_linkName__pYAao"};